// src/composables/useFileUpload.js
import axios from "axios";

export function useFileUpload() {

  const allowedTypes = [
    "image/png",
    "image/jpeg",
    "image/webp",
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", 
    "application/msword",
    "application/vnd.ms-excel", 
    "text/plain",
  ];
  const allowedExtensions = [".png", ".jpg", ".jpeg",".webp", ".pdf", ".docx", ".doc", ".xls", ".txt"];

  const validateFileType = (file) => {
    const fileType = file.type;
    const fileName = file.name.toLowerCase();

    const hasValidMime = allowedTypes.includes(fileType);
    const hasValidExt = allowedExtensions.some((ext) => fileName.endsWith(ext));

    if (!hasValidMime && !hasValidExt) {
      return {
        valid: false,
        message: "Invalid file type! Allowed File Types : PNG, JPG, JPEG,WEBP, PDF, DOCX, DOC, XLS, TXT",
      };
    }

    return { valid: true, message: "" };
  };

  const handleFileUploadImg = async (file) => {
    const { valid, message } = validateFileType(file);
    if (!valid) return { file: null, message };

    const formData = new FormData();
    formData.append("Image", file);

    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/imgpath`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      return { file: response.data.file, message: "" };
    } catch (error) {
      console.error("Image upload failed:", error);
      return { file: null, message: "Image upload failed. Please try again." };
    }
  };

  const handleFileUploadDoc = async (file) => {
    const { valid, message } = validateFileType(file);
    if (!valid) return { file: null, message };

    const formData = new FormData();
    formData.append("Document", file);

    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/docpath`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      return { file: response.data.file, message: "" };
    } catch (error) {
      console.error("Document upload failed:", error);
      return { file: null, message: "Document upload failed. Please try again." };
    }
  };

  return { handleFileUploadImg, handleFileUploadDoc };
}
